export const ambiences = newValues => {
  return newValues
}
